import { render, staticRenderFns } from "./UpdateMarque.vue?vue&type=template&id=256ca924&"
import script from "./UpdateMarque.vue?vue&type=script&lang=js&"
export * from "./UpdateMarque.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports